import React from "react"
import styles from "./OptionsMenu.module.scss"
import axios from "axios"
import toast from "react-hot-toast"
import { API_ROUTE, exportToDocx, exportToPdf } from "../../../../../utils"
import { FileItem } from "../Files"

interface OptionsMenuProps {
    item: FileItem
    x: number
    y: number
    onClose: () => void
    onRename: (id: string, name: string) => void
    onDelete: (item: FileItem) => void
    onDownloadOriginal?: (item: FileItem) => void
}

const OptionsMenu: React.FC<OptionsMenuProps> = ({
    item,
    x,
    y,
    onClose,
    onRename,
    onDelete,
    onDownloadOriginal,
}) => {
    const fetchAndDecodeContent = async () => {
        try {
            const response = await axios.get(`${API_ROUTE}/files/get-file/${item._id}`)
            const content = response.data.content

            const base64Data = content.replace(/^data:[^;]+;base64,/, "")
            const decodedContent = decodeURIComponent(escape(atob(base64Data)))

            if (!decodedContent) {
                toast.error("No content available for this file")
                return null
            }

            return { decodedContent, contentType: item.contentType }
        } catch (error) {
            toast.error("Failed to fetch file content")
            console.error("File fetch error:", error)
            return null
        }
    }

    const hasBeenConvertedFile =
        item.contentType === "text/html" || item.contentType === "application/json"

    return (
        <div
            className={styles.OptionsMenu}
            onMouseLeave={onClose}
            style={{ left: `${x}px`, top: `${y}px` }}>
            {hasBeenConvertedFile && (
                <>
                    <p>Export</p>

                    {item.originalS3Url && (
                        <div
                            className={styles.optionsItem}
                            onClick={(e) => {
                                e.stopPropagation()
                                onDownloadOriginal?.(item)
                                onClose()
                            }}>
                            Download Original
                        </div>
                    )}

                    {item.contentType === "text/html" && (
                        <>
                            <div
                                className={styles.optionsItem}
                                onClick={async (e) => {
                                    e.stopPropagation()
                                    const result = await fetchAndDecodeContent()
                                    if (result && result.contentType === "text/html") {
                                        await exportToDocx(result.decodedContent, item.name)
                                    }
                                    onClose()
                                }}>
                                DOCX
                            </div>

                            <div
                                className={styles.optionsItem}
                                onClick={async (e) => {
                                    e.stopPropagation()
                                    const result = await fetchAndDecodeContent()
                                    if (result) {
                                        const { decodedContent, contentType } = result
                                        if (contentType === "text/html") {
                                            await exportToPdf(decodedContent, item.name)
                                        } else if (contentType === "application/json") {
                                            await exportToPdf(
                                                `<pre>${JSON.stringify(
                                                    JSON.parse(decodedContent),
                                                    null,
                                                    2
                                                )}</pre>`,
                                                item.name
                                            )
                                        } else {
                                            toast.error("Unsupported content type for PDF export")
                                        }
                                    }
                                    onClose()
                                }}>
                                PDF
                            </div>
                        </>
                    )}

                    <hr />
                </>
            )}
            <div
                className={styles.optionsItem}
                onClick={(e) => {
                    e.stopPropagation()
                    onRename(item._id, item.name)
                    onClose()
                }}>
                Rename
            </div>
            <div
                className={styles.optionsItem}
                onClick={(e) => {
                    e.stopPropagation()
                    onDelete(item)
                    onClose()
                }}>
                Delete
            </div>
        </div>
    )
}

export default OptionsMenu
